import React, { useEffect, useRef } from 'react';
import { Leaf, ShieldCheck, Sparkles } from 'lucide-react';
import { santhoshaImg } from '../mock';

const About = () => {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-visible')),
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="about" ref={ref} className="py-20 md:py-28 paper-bg relative">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="reveal relative">
          <div className="relative rounded-[28px] overflow-hidden shadow-xl aspect-[4/5] max-w-md bg-gradient-to-br from-[#2c4039] to-[#1d2e2a]">
            <img
              src={santhoshaImg}
              alt="Santhosha - mental wellness counselor"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-[28px] pointer-events-none" />
          </div>
          {/* Floating quote card */}
          <div className="absolute -bottom-6 -right-3 md:-right-10 bg-[#3a5232] text-[#f0e9d2] rounded-2xl p-5 md:p-6 shadow-xl max-w-[260px]">
            <p className="font-script text-2xl text-[#d8e0b0] leading-tight">Sessions by</p>
            <p className="font-serif text-3xl md:text-4xl mt-1">Santhosha</p>
            <p className="text-[12px] mt-2 text-[#cfd6a8] tracking-wide">Mental wellness counselor</p>
          </div>
        </div>

        <div className="reveal">
          <p className="font-script text-2xl text-[#7a8a4c] mb-2">About</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2c3f25] tracking-tight leading-[1.1]">
            A calm space, <br /> a kinder path forward.
          </h2>
          <p className="mt-6 text-[#3d4a36] text-base md:text-lg leading-relaxed">
            At Natural Care, I believe healing begins with being heard. Through compassionate,
            confidential conversations, we explore what weighs on you and gently build the tools,
            mindset and resilience you need to move forward.
          </p>
          <p className="mt-4 text-[#3d4a36] text-base leading-relaxed">
            Every session is shaped around you — your pace, your story, your hope.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {[
              { icon: ShieldCheck, label: 'Confidential', sub: '100% private' },
              { icon: Leaf, label: 'Holistic', sub: 'Mind & well-being' },
              { icon: Sparkles, label: 'Personalized', sub: 'Tailored to you' },
            ].map((s, i) => (
              <div key={i} className="flex items-center gap-3 bg-[#f0e9d2] rounded-xl p-4">
                <div className="w-10 h-10 rounded-full bg-[#3a5232] flex items-center justify-center">
                  <s.icon className="text-[#f0e9d2]" size={18} />
                </div>
                <div>
                  <p className="text-[#2c3f25] font-medium text-sm">{s.label}</p>
                  <p className="text-[#5a6a4a] text-xs">{s.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
